import React from 'react';
import { useForm, FormProvider } from "./provider/formProvider"
import { FormStyle } from "./styles";


const InnerForm = ({ className, children, onSubmitCall, style }) => {

    const { onSubmit } = useForm();


    return <FormStyle

        className={className} style={style} onSubmit={(event) => {
            event.preventDefault()
            const data = onSubmit();

            onSubmitCall(data)


        }}>

        {children}

    </FormStyle>

}


const Form = ({ className = '', children, onSubmit, initialData = {}, style = {} }) => {

    return <FormProvider initialData={initialData}>
        <InnerForm className={className} style={style} onSubmitCall={onSubmit}>
            {children}
        </InnerForm>
    </FormProvider>



}


export default Form;
